export const LearningOpportunityPageStaticData = {
  overviewHeading: "Description",
  aboutSectionHeading: "The story",

  attending: {
    aboutSectionHeading: "The story",
    participantSectionHeading: "Participant information",
  },

  metadata: {
    topics: "Topics",
    studyFormat: "Study format",
    applicationPeriod: "Application period",
    studyPeriod: "Study period",
    ects: "Credits",
    hostingUniversity: "Hosting university",
    tags:"Tags",
  },

  loListSection: {
    usage: {
      heading: "People who did this learning opportunity also did",
    },
    topic: {
      heading: "More on",
    },
  },
};
